<template>
  <div class="content-i">
    <div class="content-box">
      <div class="row">
        <div class="col-lg">
          <div class="element-wrapper">
            <h6 class="element-header">Cartão SinSaúde</h6>
            <div class="element-box">
              <form @submit.prevent="buscaCartao" autocomplete="off">
                <h5 class="form-header">Validar Cartão SinSaúde</h5>
                <div class="form-desc">
                  Informe o número do cartão para garantir a legibilidade do cartão SinSaúde apresentado.
                </div>

                <div class="row" v-if="error">
                  <div class="col">
                    <div class="alert alert-danger alert-dismissible fade show" role="alert">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                      <i class="fas fa-exclamation-triangle"></i>
                      <strong>{{error.message}}</strong> 
                    </div>
                  </div>
                </div>
                <br>
                <div class="form-group col-md-6">
                  <label class="sr-only" for="nrCartao">Número Cartão</label>
                  <div class="input-group mb-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <i class="fas fa-id-card"></i>
                      </div>
                    </div>
                    <input required type="tel" class="form-control" id="nrCartao" 
                      v-model="nrCartao"
                      placeholder="Número do Cartão">
                    <div class="input-group-prepend">
                      <button class="btn btn-outline-secondary" type="submit">
                        <i class="fas fa-search"></i>
                        <span>Validar</span>
                      </button>
                    </div>
                  </div>
                </div>

                <hr>
                <div v-if="cartao">
                  <div class="row">
                    <div class="col">
                      <h6 class="form-header">Dados do cartão</h6>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <label>Plano</label>
                      <b><p>{{cartao.pedido.plano ? cartao.pedido.plano.name : 'NÃO INFORMADO'}}</p></b>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label>NRº Cartão</label>
                      <b><p>{{cartao.numeroCartao}}</p></b>
                    </div>
                    <div class="col">
                      <label>Situação</label>
                      <p>
                        <span class="status-pill smaller green"></span>
                        <b>{{cartao.status}}</b>
                      </p>
                    </div>
                    <div class="col">
                      <label>Data Ativação</label>
                      <b><p>{{formataData(cartao.dataAtivacao)}}</p></b>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <h6 class="form-header">Dados do Cliente</h6>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <label>Nome</label>
                      <b><p>{{cartao.pedido.client.name}}</p></b>
                    </div>
                    <div class="col">
                      <label>Sexo</label>
                      <b><p>{{cartao.pedido.client.sexo}}</p></b>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label>Data Nascimento</label>
                      <b><p>{{formataData(cartao.pedido.client.dataNascimento)}}</p></b>
                    </div>
                    <div class="col">
                      <label>CPF</label>
                      <b><p>{{formataCPF(cartao.pedido.client.cpf)}}</p></b>
                    </div>
                    <div class="col">
                      <label>Naturalidade</label>
                      <b><p>{{cartao.pedido.client.naturalidade}}/{{cartao.pedido.client.ufNaturalidade}}</p></b>
                    </div>
                  </div>

                  <template v-if="cartao.pedido.client.dependentes.length > 0">
                    <div class="row">
                      <div class="col">
                        <h6 class="form-header">Dependentes</h6>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div class="element-box-tp">
                          <div class="table-responsive">
                            <table class="table table-padded table-bordered table-sm">
                              <thead>
                                <tr>
                                  <th style="width: 60%">Nome</th>
                                  <th>CPF</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="dep in cartao.pedido.client.dependentes" :key="dep.cpf">
                                  <td>{{dep.NomeDepedente || dep.name}}</td>
                                  <td>{{formataCPF(dep.cpf || dep.CPF_Depedente)}}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from 'axios'
import moment from 'moment'

export default {
  created () {
    moment.locale('pt-br')
  },
  data () {
    return {
      cartao: null,
      nrCartao: null,
      error: null
    }
  },
  methods: {
    buscaCartao () {
      this.$store.dispatch('setLoading', true)
      http.get(`/cartao/${this.nrCartao}`)
        .then(async response => {
          this.cartao = response.data
          // recuperar _id saude e carregar os dependentes. deste (Saude)
          if (this.cartao.pedido) {
            const responseClient = await http.get(`/clients/${this.cartao.pedido.client._id}`)
            this.cartao.pedido.client.dependentes = responseClient.data.dependentes
          }
          this.error = null
          this.$store.dispatch('setLoading', false)
        })
        .catch(error => {
          this.cartao = null
          this.error = error.response.data
          this.$store.dispatch('setLoading', false)
        })
    },
    formataData (data) {
      return moment(data).format('DD/MM/YYYY')
    },
    formataCPF (cpf) {
      if (!cpf || cpf.length < 11) return ''
      return cpf.replace(/(\d\d\d)(\d\d\d)(\d\d\d)(\d\d)/g, '$1.$2.$3-$4')
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/dashboard/ValidacaoCartaoSinsaude.vue